import styled from 'styled-components';
import { contentHorizontalSpacing } from '../menu-modal.styles';

export const SpecialInsAdditionalText = styled.div`
  ${contentHorizontalSpacing}
`;
